import React from 'react';

const BreachedSVG = () =>
  <svg height="53px" width="53px" version="1.1" viewBox="0 0 53 53">
    <g fill="none" stroke="none" strokeLinecap="square" strokeWidth="1">
      <g transform="translate(-566.000000, -258.000000)">
        <g transform="translate(157.000000, 115.000000)">
          <g transform="translate(-1.000000, 107.000000)">
            <g transform="translate(39.000000, 29.000000)">
              <g transform="translate(371.000000, 0.000000)">
                <g transform="translate(0.000000, 7.000000)">
                  <path
                    d="M52.5093,26.2547 C52.5093,11.7547 40.7543,-0.0003 26.2543,-0.0003 C11.7543,-0.0003 0.0003,11.7547 0.0003,26.2547 C0.0003,40.7547 11.7543,52.5087 26.2543,52.5087 C40.7543,52.5087 52.5093,40.7547 52.5093,26.2547"
                    fill="#ECECEC"
                  />
                  <g transform="translate(13.000000, 17.000000)">
                    <path
                      d="M13.2544,0.8172 C7.6294,0.8172 2.8254,4.3162 0.8794,9.2552 C2.8254,14.1932 7.6294,17.6922 13.2544,17.6922 C18.8794,17.6922 23.6834,14.1932 25.6294,9.2552 C23.6834,4.3162 18.8794,0.8172 13.2544,0.8172"
                      fill="#FFFFFF"
                    />
                    <path
                      d="M13.2544,0.8172 C7.6294,0.8172 2.8254,4.3162 0.8794,9.2552 C2.8254,14.1932 7.6294,17.6922 13.2544,17.6922 C18.8794,17.6922 23.6834,14.1932 25.6294,9.2552 C23.6834,4.3162 18.8794,0.8172 13.2544,0.8172 Z"
                      stroke="#222228"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M13.2544,14.1454 C10.5544,14.1454 8.3634,11.9544 8.3634,9.2544 C8.3634,6.5544 10.5544,4.3634 13.2544,4.3634 C15.9544,4.3634 18.1454,6.5544 18.1454,9.2544 C18.1454,11.9544 15.9544,14.1454 13.2544,14.1454 Z"
                      stroke="#EC5424"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M13.2544,7.1302 C12.0794,7.1302 11.1304,8.0792 11.1304,9.2552 C11.1304,10.4302 12.0794,11.3792 13.2544,11.3792 C14.4304,11.3792 15.3794,10.4302 15.3794,9.2552 C15.3794,8.0792 14.4304,7.1302 13.2544,7.1302"
                      fill="#222228"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>;

export default BreachedSVG;



// WEBPACK FOOTER //
// ./src/svg/BreachedSVG.js